import React, {useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";

import {TbAlertSquareRoundedFilled, TbArrowBadgeLeft} from "react-icons/tb";
import {BiCoin, BiInfoCircle, BiSolidCubeAlt} from "react-icons/bi";
import {MdMedicalServices} from "react-icons/md";
import {getService} from "../api/ServiceApi";
import {showError, showSuccess} from "../../../utils/toastHelper";
import Loading from "../../../layouts/Loading";
import Header from "../../../layouts/Header";
import {GrCatalog, GrShareOption} from "react-icons/gr";
import {IoBookmarks, IoBookmarksOutline} from "react-icons/io5";
import {HiOutlineVideoCameraSlash} from "react-icons/hi2";
import {ImDownload, ImPlay} from "react-icons/im";
import {LuFileX2} from "react-icons/lu";
import ServiceSlideShow from "./ServiceSlideShow";
import {config} from "localforage";
import {GiMoneyStack, GiTakeMyMoney} from "react-icons/gi";

const currencyFormat = Intl.NumberFormat('en-US');

const Service = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const config = window.APP_CONFIG;

    const [service, setService] = React.useState([]);
    const [cart, setCart] = React.useState([]);
    const [loading, setLoading] = useState(true);
    const [loadVideo, setLoadVideo] = useState(false);

    React.useEffect(() => {

        let cartItems = JSON.parse(window.localStorage.getItem("cart"));

        if (cartItems) {
            setCart(cartItems)
        }

        const fetchService = async () => {
            try {
                const params = {
                    vendor: 1,
                }
                const data = await getService(id, params);
                setService(data?.data || []);

                setTimeout(() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }, 400)
            } catch (err) {
                showError(err);
            } finally {
                setLoading(false);
            }
        };
        fetchService();
        setTimeout (() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },400)
    }, [id]);




    const onContinueClick = () => {
        onPlusClick(id);
        navigate('/request-options');
    }

    const onPlusClick = (serviceID , price = 0) => {
        let cartItems = null;
        let count = 1;
        cartItems = [];
        cartItems.push({'item': serviceID, 'count': count})
        setCart(cartItems);
        window.localStorage.setItem("cart", JSON.stringify(cartItems));
    }

    const stripHtml = (html) => {
        if (!html) return "";
        return html.replace(/<[^>]*>?/gm, '');
    };
    const handleShare = async () => {
        const cleanDescription = stripHtml(service?.description);

        const shareData = {
            title: service.title,
            text: `🛍️ ${service.title} \n\n${cleanDescription.substring(0, 100) + '... \n\n' || ''}`,
            url: window.location.href,
        };

        try {
            if (navigator.share) {
                await navigator.share(shareData);
            } else {
                // اگر مرورگر پشتیبانی نکنه، لینک رو کپی کن یا راه حل جایگزین
                showError("مرورگر شما از اشتراک‌گذاری پشتیبانی نمی‌کند.");
            }
        } catch (err) {
            console.error("خطا در اشتراک‌گذاری:", err);
        }
    };

    const onFavoriteClick = async () => {
/*        try {

            const result = await makeFavorite(id);
            showSuccess(result.message);
            try {
                const params = {
                    vendor: 1,
                }
                const data = await getProduct(id, params);
                setProduct(data?.data || []);

            } catch (err) {
                showError(err);
            } finally {
                setLoading(false);
            }
        } catch (err) {
            showError(err);
        } finally {
            setLoading(false);
        }*/
    }

    if (loading) return <Loading/>;
    const isCatalogEmpty = !service.catalog || (Array.isArray(service.catalog) && service.catalog.length === 0) || (typeof service.catalog === 'object' && !Array.isArray(service.catalog) && !service.catalog.path);

    return (
        <React.Fragment>

            <Header title={service.title} hasBack={true}/>
            <div className="modal fade bottom-sheet " id="relatedMedia" tabIndex="-1"
                 aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-bottom mobile-size-option">
                    <div className="modal-content">
                        <div className="modal-header rtl w-100 row">

                            <div className="col-8">
                                <h5 className="modal-title fs-6 fw-bold" id="exampleModalLabel">
                                    {
                                        loadVideo ? 'مشاهده ویدئوی محصول' : 'دانلود فایل ها'
                                    }
                                </h5>
                            </div>
                            <div className="col-4 text-start">
                                <button type="button" className="btn-close " data-bs-dismiss="modal"
                                        aria-label="Close"></button>
                            </div>


                        </div>
                        <div className="modal-body ">

                            {
                                loadVideo ? <div className="row">
                                        <div className="col-12 text-center">
                                            {
                                                service?.video?.length > 0 ?
                                                    <p dangerouslySetInnerHTML={{__html: service.video}}
                                                       className='w-100'></p>
                                                    :
                                                    <p className='text-center text-muted'>
                                                        <HiOutlineVideoCameraSlash className='mx-2 text-big-2'/>
                                                        ویدئویی برای این محصول بارگزاری نشده است!
                                                    </p>
                                            }
                                        </div>
                                    </div> :
                                    <div className="row">
                                        {
                                            !isCatalogEmpty ?
                                                <div className="col-12 text-center">
                                <span className='btn btn-dark w-100'
                                      onClick={() => {
                                          window.open(
                                              `${service.catalog?.path}?external=true`
                                          )
                                      }}
                                >
                                        <ImDownload className='text-big-3 ms-2'/>
                                        دانلود کاتالوگ محصول
                                </span>

                                                </div> :
                                                <div className="col-12 text-center text-muted">
                                                    <LuFileX2 className='mx-2 text-big-2'/>
                                                    کاتالوگی برای این محصول بارگزاری نشده است!
                                                </div>
                                        }
                                        <div className="col-12 border-top my-3 fw-bold pt-3">
                                            سایر فایلها
                                        </div>
                                        {service?.files?.length > 0 ?
                                            <div className="col-12 ">
                                                {
                                                    service?.files?.map((file, index) => {
                                                        return (
                                                            <span className='btn btn-secondary w-100 my-1'
                                                                  onClick={() => {
                                                                      window.open(
                                                                          `${file.path}?external=true`
                                                                      )
                                                                  }}
                                                            >
                                        <ImDownload className='text-big-3 ms-2'/>
                                                                {
                                                                    file.title ? file.title : `فایل ${index + 1}`
                                                                }
                                </span>
                                                        )
                                                    })
                                                }
                                            </div>
                                            :
                                            <div className="col-12 text-center text-muted">
                                                <LuFileX2 className='mx-2 text-big-2'/>
                                                فایلی برای این محصول بارگزاری نشده است!
                                            </div>
                                        }
                                    </div>
                            }
                        </div>

                    </div>
                </div>
            </div>
            {
                !loading &&
                <section className="container service-page mt-2 py-5 rtl   ">
                    <div className="row  mx-0 px-0 py-2 rounded-4 mb-3 bg-white">
                        <div className="col-7 me-0 text-end">
                       <span className='text-small-3 bg-warning-subtle text-warning-emphasis px-3 py-1 rounded'
                             data-bs-toggle="modal"
                             data-bs-target="#relatedMedia"
                             onClick={() => {
                                 setLoadVideo(false)
                             }}
                       >
                            <GrCatalog className='ms-1 text-big-1 text-warning'

                            />
                            کاتالوگ
                       </span>
                            <span className='text-small-3 bg-info-subtle text-info-emphasis px-3 py-1 rounded me-2'
                                  data-bs-toggle="modal"
                                  data-bs-target="#relatedMedia"
                                  onClick={() => {
                                      setLoadVideo(true)
                                  }}
                            >
                            <ImPlay className='ms-1 text-big-1 text-info'

                            />
                            ویدئو
                       </span>
                        </div>

                        <div className="col-5 text-start">
                            <GrShareOption className=' text-big-4 text-muted'
                                           onClick={handleShare}
                            />
                            {
                                service.is_favorite > 0 ?
                                    <IoBookmarks className='me-3  text-big-4 text-third-color'
                                                 onClick={onFavoriteClick}
                                    />
                                    :
                                    <IoBookmarksOutline className='me-3  text-big-4 text-muted'
                                                        onClick={onFavoriteClick}
                                    />
                            }

                        </div>

                    </div>
                    <div className="row pb-5 mb-5">
                        <ServiceSlideShow images={[service.image, ...service.images] || []}/>


                        <div className="col-12 px-3 ">
                            <div className="fw-bold text-end  my-3">
                                <BiSolidCubeAlt className='mx-2'/>
                                {service.title}

                                <div className='mt-2 text-small-3 text-muted opacity-75 mx-2 text-justify'>
                                    {service.brief}
                                </div>

                            </div>
                        </div>

                        {service.price > 0 ?
                            <div className="col-12">
                                <div className="row vendor-product-in mx-2 py-3 text-small-2">
                                    <div className="col-1">
                                        <GiMoneyStack/>
                                    </div>
                                    <div className="col-4">
                                        قیمت:
                                    </div>
                                    <div className="col-7 text-start ps-2 text-big-1 fw-bold">
                                        {currencyFormat.format(service.price)}
                                        {" "}
                                        {config.currency}
                                    </div>
                                </div>
                            </div> :
                            <div className="col-12 me-3 my-2">
                                <span className='text-primary fw-bold text-small-3'>
                                    <TbAlertSquareRoundedFilled className='ms-1' />
                                    هزینه دقیق پس از مراجعه همکاران ما و بازدید مشخص خواهد شد
                                </span>
                            </div>
                        }
                        {service.prepayment > 0 &&
                        <div className="col-12">
                            <div className="row vendor-product-in mx-2 py-3 text-small-2">
                                <div className="col-1">
                                    <GiTakeMyMoney />
                                </div>
                                <div className="col-5">
                                    پیش پرداخت (بیعانه):
                                </div>
                                <div className="col-6 text-start ps-2 text-big-1 fw-bold">
                                    {currencyFormat.format(service.prepayment)}
                                    {" "}
                                    {config.currency}
                                </div>
                                <div className="col-12 mt-2 border-top pt-3 text-small-1 text-justify text-muted">
                                    <ul>
                                        <li>
                                             ثبت درخواست با پرداخت مبلغ بیعانه  امکان پذیر است.
                                        </li>
                                        <li>
                                            مبلغ پیعانه ممکن است با توجه به آدرس انتخابی افزایش پیدا کند.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        }
                        <div className="col-12 p-0 mt-5">
                            <div className="row  mx-2 p-2  ">
                                <div className="col-12 fw-bold text-small-1">
                                    <BiInfoCircle className='ms-2'/>
                                    توضیحات محصول
                                </div>


                                <div className="col-12 text-justify mt-3 text-small-1">
                                    <p dangerouslySetInnerHTML={{__html: service.description}}></p>
                                </div>

                            </div>

                        </div>
                    </div>

                    <div className="row ">
                        <div className="col-12 p-2 fixed-bottom  action-footer mobile-size-option">
                            <button
                                className="submit-btn"
                                onClick={onContinueClick}
                            >
                                <TbArrowBadgeLeft className='mx-2 text-big-4'/>
                                ثبت درخواست
                                <span className="badge  p-2 float-start fw-normal">


                    </span>
                            </button>
                        </div>
                    </div>


                </section>
            }
        </React.Fragment>
    );
};

export default Service;